import { Router } from '@vaadin/router';
import { QRPortalNotFoundView } from './views/QRPortalNotFoundView';
import { QRPortalResourceCleaningView } from './views/QRPortalResourceCleaningView';
import { QRPortalResourceCleaningDocumentView } from './views/QRPortalResourceCleaningDocumentView';
export const router = new Router();
router.setRoutes([
    {
        path: '/resource/:hash/cleaning',
        component: QRPortalResourceCleaningView.is,
    },
    {
        path: '/resource/:hash/cleaning/documents',
        component: QRPortalResourceCleaningDocumentView.is,
    },
    {
        path: '(.*)',
        component: QRPortalNotFoundView.is,
    },
]);
